import {Box} from "@mui/material";
import Loading from "../../../components/loader/Loading";

const ProfileFormButtons = ({submitForm, cancelForm, loading}) => {
    return (
        <Box
            sx={{
                display: "flex",
                gap: "10px",
            }}
        >
            <button
                onClick={submitForm}
                className="btn btn-blue"
                style={{width: "150px"}}
            >
                {
                    loading ? (
                        <Loading color="#fff"/>
                    ) : "ذخیره تنظیمات"
                }
            </button>
            <button
                onClick={cancelForm}
                className="btn btn-softred"
                style={{width: "110px"}}
            >
                انصراف
            </button>
        </Box>
    );
};

export default ProfileFormButtons;